import { Box, Paper, Popover, Skeleton, Typography } from '@mui/material';
import React from 'react';
import { Row } from 'ui/Flex';

interface TotalsBoxPopupProps {
    title: string;
    anchor: HTMLDivElement;
    onClose?: () => void;
    datePoints: [Date, Date, Date];
    value: string;
    retroValue: string;
    valueLoading?: boolean;
    retroValueLoading?: boolean;
    difference: number;
    subtitle: string;
}

export const TotalsBoxPopup: React.FC<TotalsBoxPopupProps> = ({
    title,
    subtitle,
    anchor,
    onClose,
    datePoints,
    value,
    retroValue,
    valueLoading,
    retroValueLoading,
    difference
}) => {
    const renderDateItem = React.useCallback(
        (item: Date) => (
            <Typography
                key={item.toLocaleDateString()}
                variant="caption"
                sx={{ fontWeight: 600, opacity: 0.6, mt: 0.25 }}
            >
                {item.toLocaleDateString()}
            </Typography>
        ),
        []
    );
    return (
        <Popover
            open={!!anchor}
            anchorEl={anchor}
            onClose={onClose}
            aria-hidden="false"
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left'
            }}
            sx={{
                pointerEvents: 'none'
            }}
            disableRestoreFocus
        >
            <Paper elevation={3} sx={{ p: 1, minWidth: 400 }}>
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 'bold',
                        opacity: 0.75
                    }}
                >
                    {title}
                </Typography>
                <Typography variant="caption" sx={{ fontWeight: 600, opacity: 0.6, mt: 0.25 }}>
                    {subtitle}
                </Typography>
                <Row flex={1}>
                    <Box flexBasis="50%">
                        <Box flex={1} justifyContent="center" display="flex">
                            <Typography
                                variant="h6"
                                align="center"
                                sx={{
                                    fontWeight: 'bold',
                                    mt: 0.25
                                }}
                            >
                                {retroValueLoading ? <Skeleton width={100} /> : retroValue}
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                borderLeft: '1px solid',
                                borderBottom: '5px solid',
                                borderColor: 'divider',
                                opacity: 0.5,
                                height: '15px'
                            }}
                        />
                    </Box>
                    <Box flexBasis="50%">
                        <Box flex={1} justifyContent="center" display="flex">
                            <Typography
                                variant="h6"
                                align="center"
                                sx={{
                                    fontWeight: 'bold',
                                    mt: 0.25
                                }}
                            >
                                {valueLoading ? <Skeleton width={100} /> : value}
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                borderLeft: '1px solid',
                                borderBottom: '5px solid',
                                borderRight: '1px solid',
                                opacity: 0.5,
                                borderColor: difference < 0 ? 'error.main' : 'success.main',
                                height: '15px'
                            }}
                        />
                    </Box>
                </Row>
                <Row align="space-between" valign="center">
                    {datePoints.map(renderDateItem)}
                </Row>
            </Paper>
        </Popover>
    );
};
